<template>
  <div>
    ID Namestitvenega Obrata: {{report.idNO}}
    <br>
    Leto: {{report.leto}}
    <br>
    Mesec: {{report.mesec}}
    <br>
    Odprto dni: {{report.odprtDni}}
    <br>
    Število dodatnih ležišč: {{report.stDodatnihlezisc}}
    <br>
    Število prodanih namestitvenih enot: {{report.stProdanihNE}}
    <br>
    Status poročila: {{report.statusPor | status}}
    <br>
    Updated: {{report.updated | date}}
  </div>
</template>

<script>
  import moment from 'moment';

  export default {
    name: 'eTurizem',
    props: ['report'],
    filters: {
      status: function(value){
        let status = "";
        switch(value) {
          case 11:
            status = "ODPRT - Turisti so prijahali"
            // code block
            break;
          case 12:
            status = "ODPRT - Turistov ni bilo"
            break;
          case 50:
            status = "ZAČASNO ZAPRT - Drugi razlogi"
            break;
          case 51:
            status = "ZAČASNO ZAPRT - Adaptacija"
            break;
          case 54:
            status = "ZAČASNO ZAPRT - Sezonska zaprtost"
            break;
          case 61:
            status = "PRENEHANJE ODDAJANJA NASTANITVENIH KAPACITET TURISTOM"
            break;
          case 62:
            status = "ZAČASNO ZAPRT - Nastanitvene kapacitete še v pripravi"
            break;
          default:
            status = "";
        }
        return status;
      },
      date: function(date){
        if(!date) return '';
        return moment(date).format('DD/MM/YYYY HH:mm:ss');
      },
    },
  }
</script>
